function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video:not([muted])').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      const mediatype = button.closest(".product__modal-opener").getAttribute("data-media-type");
      console.log("mediatype",mediatype);
      if (modal) modal.show(button,mediatype);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

/**
 * VariantSelects - Custom element for managing product variant selection
 * Handles variant picker interactions, metavariant data, and media gallery updates
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    // Organize swatches into groups if grouping is enabled in the product's metafields
    if (this.dataset.groupSwatches) {
      this.organizeSwatchesByGroup();
    }

    // Initialize state
    this.updateSelectedOptions();
    this.updateVariantId();
    this.updateMetavariant();
    this.renderMetavariantInfo();
    
    this.addEventListener('change', this.onVariantChange);
    // Wait for the media gallery element to initialize
    document.addEventListener('media-gallery:ready', this.onMediaGalleryReady.bind(this), { once: true });
  }

  /**
   * Visually group swatches based on their metaobject settings
   */
  organizeSwatchesByGroup() {
    this.querySelectorAll('fieldset[data-picker-type="swatch"]').forEach((fieldset) => {
      const swatches = fieldset.querySelectorAll('.swatch-input');
      const swatchGroups = [...new Set(Array.from(swatches).map((swatch) => swatch.dataset.group))];

      // Bail if there are fewer than 2 groups
      if (swatchGroups.length < 2) return;

      const allGroupContainer = document.createElement('div');
      allGroupContainer.classList.add('swatch-group-wrapper');

      // Create a container for each group
      swatchGroups.forEach((group) => {
        const groupSwatches = fieldset.querySelectorAll(`.swatch-input[data-group="${group}"]`);
        const groupContainer = document.createElement('div');
        groupContainer.classList.add('swatch-group');
        
        // Add group label
        const groupLabel = document.createElement('div');
        groupLabel.textContent = group;
        groupLabel.classList.add('swatch-group__label');

        groupContainer.append(groupLabel)
        groupSwatches.forEach((swatch) => {
          groupContainer.append(swatch);
        });

        allGroupContainer.append(groupContainer);
      });

      fieldset.prepend(allGroupContainer);
    });
  }

  /**
   * Can be called when variant inputs are modified externally (e.g. by infinite-options.js)
   * Refreshes all variant-related state and UI
   */
  onFieldsUpdated() {
    this.updateSelectedOptions();
    this.updateVariantId();
    this.updateMetavariant();
    this.renderMetavariantInfo();
    this.updateVariantImageSet();
  }

  /**
   * Main event handler for variant selection changes
   * Updates all variant-related state and UI
   * @param {Event} event - The change event from variant inputs
   */
  onVariantChange(event) {
    this.updateSelectedOptions();
    this.updateVariantId();

    // If the first option changed and there's no matching variant, we 
    // select the first available variant with the new first option
    if (!this.currentVariant && event.target.value === this.options[0]) {
      this.switchToAvailableVariant();
    }

    // Update UI
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateMetavariant();
    this.renderMetavariantInfo();
    this.updateVariantImageSet();

    // Handle unavailable variants
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // Update URL, form inputs, and product info for available variants
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  /**
   * Event handler for when media gallery is ready
   * Stores reference to media gallery and updates variant images
   * @param {Event} event - The media-gallery:ready event
   */
  onMediaGalleryReady(event) {
    this.mediaGallery = event.target;
    this.updateVariantImageSet();
  }

  /**
   * Updates the currently selected options from all variant inputs
   * Handles both selects and radio button fieldsets, but selects have not been tested thoroughly
   */
  updateSelectedOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });

    // Polish translation mapping for infinite options to match metaobject values
    // This may no longer be necessary
    if (Shopify.routes.root === '/pl/') {
      this.options = this.options.map((option) => {
        switch (option) {
          case 'Block': return 'Blok';
          case 'Legs': return 'Nogi';
          case 'Shelf': return 'Półka';
          case 'Sleeper': return 'Funkcja spania';
          default: return option;
        }
      })
    }
  }

  /**
   * Determines the current variant based on selected options
   * Prioritizes variants with default_select metafield, then matches by options
   */
  updateVariantId() {
    const allVariants = this.getVariantData();
    
    // First try to find variant with default_select = true
    let selectedVariant = allVariants.find(variant => {
      const defaultSelect = variant.metafields?.custom?.default_select?.value;
      return defaultSelect === true;
    });
  
    // If no default selected variant found, match by options
    if (!selectedVariant) {
      selectedVariant = allVariants.find(variant => {
        return !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false);
      });
    }
  
    this.currentVariant = selectedVariant;
  }

  /**
   * Selects the first available variant
   * Updates both internal state and UI
   */
  switchToAvailableVariant() {
    const firstAvailableVariant = this.getVariantData().find((variant) => variant.option1 === this.options[0] && variant.available);
    if (firstAvailableVariant) {
      this.options = [firstAvailableVariant.option1, firstAvailableVariant.option2, firstAvailableVariant.option3].filter(Boolean);
      this.updateVariantId();
    }

    // Update all input elements to reflect the new selection
    this.querySelectorAll('select, fieldset').forEach((element, index) => {
      if (element.tagName === 'SELECT') {
        element.value = this.options[index];
        this.updateSelectedSwatchValue({ target: element });
      }
      if (element.tagName === 'FIELDSET') {
        element.querySelectorAll('input').forEach((radio) => {
          radio.checked = radio.value === this.options[index];
          if (radio.checked) {
            this.updateSelectedSwatchValue({ target: radio });
          }
        });
      }
    });
  }

  /**
   * Updates swatch preview image based on selected variant option
   * @param {HTMLElement} param0.target - The input element that changed
   */
  updateSelectedSwatchValue({ target }) {
    const { name, tagName } = target;

    // Handle dropdown select elements
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } 
    // Handle radio button inputs
    else if (tagName === 'INPUT' && target.type === 'radio') {
      // Update text labels for selected swatch values
      const selectedSwatchValues = this.querySelectorAll(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValues?.length) {
        const inputLabel = this.querySelector(`label[for="${target.id}"]`)?.title;
        selectedSwatchValues?.forEach(el => el.textContent = inputLabel);
      }

      // Update swatch zoomed in background image
      const selectedDropdownSwatch = this.querySelector(`[data-selected-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatch) return;
      
      let selectedSwatchBackground = target.labels[0].querySelector('.swatch')?.style.getPropertyValue('--swatch--background');
      // Safari escapes some characters when using `getPropertyValue()`
      selectedSwatchBackground = selectedSwatchBackground.replaceAll('\\', '');
      // Set a larger size for the selected swatch image
      selectedSwatchBackground = selectedSwatchBackground.replace('width=80', 'width=440');

      selectedDropdownSwatch.style.setProperty('--swatch--background', selectedSwatchBackground);
    }
  }

  /**
   * Updates the browser URL to reflect the current variant selection
   * Only updates if URL updating is enabled and a variant is selected
   */
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${window.location.origin}${window.location.pathname}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  /**
   * Updates hidden variant ID inputs in product forms
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /**
   * Updates the availability status of variant options based on current selection
   * Disables unavailable combinations and updates option text accordingly
   */
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return; // Skip first option
      
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  /**
   * Sets the availability state for a list of input elements
   * @param {Array} elementList - Array of input/option elements to update
   * @param {Array} availableValuesList - Array of available option values
   */
  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
        element.classList.toggle('visually-disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  /**
   * Updates pickup availability information for the current variant
   * Fetches availability data if variant is available, clears it otherwise
   */
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  /**
   * Removes any error messages displayed in the product form
   * Delegates to the product-form component's error handling
   */
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  /**
   * Updates the current metavariant based on selected options
   * Metavariants are metaobjects that contain additional information about a variant, like descriptions, SKUs, and image sets
   */
  updateMetavariant() {
    const metavariantData = this.getMetavariantData();

    if (!metavariantData?.length || !this.options?.length) return;

    this.metavariant = metavariantData.find((metavariant) => {
      return metavariant.option_values.every((option) => this.options.includes(option.value));
    });
  }

  /**
   * Renders metavariant information to the DOM
   * Updates descriptions, SKU, and creates hidden form inputs
   */
  renderMetavariantInfo() {
    if (!this.metavariant) return;
    
    let { description, description_short, product_sort_description, sku = '' } = this.metavariant;

    // Update product descriptions
    if (description) {
      document.querySelectorAll(`.ProductAccordion-description-${this.dataset.section}`)?.forEach((element) => {
        element.innerHTML = description;
      });
    }
    if (description_short) {
      const shortDescriptionElement = document.querySelector(`[id^="ProductShortDescription-${this.dataset.section}"]`)
      if (shortDescriptionElement) shortDescriptionElement.textContent = description_short;
    }

    if (product_sort_description) {
      const productshortDescriptionElement = document.querySelector(`[id^="ProductpriceDescriptions-${this.dataset.section}"]`)
      if (productshortDescriptionElement) productshortDescriptionElement.textContent = product_sort_description;
    }

    if (sku) {
      // Replace the orientation (L/R) in the SKU. This is done here so we don't have to
      // maintain the orientation in the variant data.
      const orientationOption = this.options.find((option) => ['Left', 'Right'].includes(option));
      if (orientationOption) {
        sku = sku.replace(/[LR]/, orientationOption.charAt(0));
      }

      // Update visible SKU element with delay to ensure DOM is ready
      const skuElement = document.querySelector(`[id^="Sku-${this.dataset.section}"]`);
      setTimeout(() => {
        skuElement.textContent = sku;
      }, 2000);
    }
    
    // Create or update hidden SKU input for form submission
    let hiddenSkuInput = document.querySelector('[name="properties[_SKU]"]');
    if (!hiddenSkuInput) {
      hiddenSkuInput = document.createElement('input');
      hiddenSkuInput.setAttribute('type', 'hidden');
      hiddenSkuInput.setAttribute('name', 'properties[_SKU]');
      document.querySelector(`[id^="product-form-${this.dataset.section}"]`)?.append(hiddenSkuInput)
    }
    hiddenSkuInput.value = sku;
  }

  /**
   * Updates the media gallery with variant-specific images and videos
   * Handles image mirroring for left/right orientations and maintains video content
   */
  updateVariantImageSet() {
    // Cache initial video slides on first run
    if (!this.initialVideoSlides) {
      this.initialVideoSlides = this.mediaGallery.elements.viewer.querySelectorAll('li[data-media-id]:has(.media-type-video)');
      this.initialVideoThumbnailSlides = this.mediaGallery.elements.thumbnails.querySelectorAll('li:has(.icon-play)');
    }

    let imageSet = this.metavariant

    if (!imageSet) {
      return;
    }

    // Clone base slide templates for creating new slides
    const baseSlide = this.mediaGallery.elements.viewer.querySelector('li[data-media-id]').cloneNode(true);
    const baseThumbnailSlide = this.mediaGallery.elements.thumbnails.querySelector('li').cloneNode(true);
    const baseVideoSlide = this.initialVideoSlides && this.initialVideoSlides[0] ? this.initialVideoSlides[0].cloneNode(true) : null;
    const baseVideoThumbnailSlide = this.initialVideoThumbnailSlides && this.initialVideoThumbnailSlides[0] ? this.initialVideoThumbnailSlides[0].cloneNode(true) : null;
    

    const slideList = this.mediaGallery.elements.viewer.querySelector('ul');
    const thumbnailList = this.mediaGallery.elements.thumbnails.querySelector('ul');

    const newSlides = [];
    const newThumbnailSlides = [];

    let metavariantHasVideo = false;

    /**
     * Helper function to replace image sources and srcsets
     * Handles protocol normalization and maintains responsive image sizing
     */
    function replaceImageSrc(imgElement, newBaseUrl) {
      const normalizeProtocol = (url) => url.replace(/^(https?:)?\/\//, 'https://');
      
      newBaseUrl = normalizeProtocol(newBaseUrl);
      imgElement.src = newBaseUrl

      if (!imgElement.hasAttribute('srcset')) {
        return;
      }

      const srcset = imgElement.getAttribute('srcset');

      const newSrcset = srcset.replace(/(https?:)?\/?\/[^\s,]+/g, (match) => {          
        // Check if the URL is already using the new base URL
        if (match.startsWith(newBaseUrl)) {
          return match;
        }

        // Construct the new URL based on the original path
        const url = new URL(match, newBaseUrl);
        const newUrl = new URL(newBaseUrl);
        newUrl.searchParams.set('width', url.searchParams.get('width'));
        return newUrl.href;
      });
  
      imgElement.setAttribute('srcset', newSrcset);    
    }

    // Images
    imageSet.media.map((media, index) => {
      const mediaType = media?.media_type ?? 'image';
      if (mediaType === 'video') {
        metavariantHasVideo = true;

        if (!baseVideoSlide) {
          metavariantHasVideo = false;
          console.warn('Metavariant has video, but no video slide found to clone. Add a video to this product\'s media gallery.');
        }
      }
      const mediaId = `${this.dataset.section}-${imageSet.media_ids[index]}`;
      const slideId = `Slide-${this.dataset.section}}-${mediaId}`;
      const thumbnailSlideId = `Slide-Thumbnails-${mediaId}`;
      const thumbnailId = `Thumbnail-${mediaId}`;
      const isMirrored = this.options.includes('Left') && mediaType === 'image' && !media.includes('technical_draw');

      const newSlide = (mediaType === 'image' ? baseSlide : baseVideoSlide).cloneNode(true);
      newSlide.id = slideId;
      newSlide.dataset.mediaId = mediaId;
      newSlide.classList.toggle('is-active', index === 0);
      if (mediaType === 'image') {
        replaceImageSrc(newSlide.querySelector('img'), media);
        newSlide.querySelector('img.image-magnify-hover').dataset.mirror = isMirrored;
      } else {
        newSlide.querySelector('deferred-media template').content.querySelector('source').src = media.sources.find((source) => source.height === 1080).url;
        newSlide.style.opacity = 1;
      }

      // Update Fancybox lightbox attributes for gallery functionality
      // This ensures the lightbox opens with the correct media source
      const fancyboxLink = newSlide.querySelector('a[data-fancybox="gallery"]');
      if (fancyboxLink) {
        // Determine the appropriate source URL for the lightbox:
        // - For images: use the media URL directly
        // - For videos: use the preview image URL (since Fancybox displays static previews for videos)
        const fancyboxSrc = mediaType === 'image' ? media : media.preview_image?.src;
        if (fancyboxSrc) {
          fancyboxLink.setAttribute('data-src', fancyboxSrc);
        }
      }

      // Create corresponding thumbnail slide
      const newThumbnailSlide = (mediaType === 'image' ? baseThumbnailSlide : baseVideoThumbnailSlide).cloneNode(true);
      newThumbnailSlide.id = thumbnailSlideId;
      newThumbnailSlide.dataset.target = mediaId;
      newThumbnailSlide.dataset.mediaPosition = index + 1;
      newThumbnailSlide.querySelector('img').id = thumbnailId;
      newThumbnailSlide.querySelector('img').dataset.mirror = isMirrored;
      replaceImageSrc(newThumbnailSlide.querySelector('img'), mediaType === 'image' ? media : media.preview_image.src);
      
      // Set first thumbnail as active
      const thumbnailButton = newThumbnailSlide.querySelector('button');
      thumbnailButton.ariaCurrent = index === 0 ? 'true' : undefined;

      newSlides.push(newSlide);
      newThumbnailSlides.push(newThumbnailSlide);
    });

    // Replace all slides with new variant-specific content
    slideList.replaceChildren(...newSlides);
    thumbnailList.replaceChildren(...newThumbnailSlides);
    
    // Add the product's video to the gallery if the metavariant doesn't have one
    if (!metavariantHasVideo && this.initialVideoSlides && this.initialVideoSlides[0]) {
      const videoSlide = this.initialVideoSlides[0].cloneNode(true);
      videoSlide.style.opacity = 1;
      slideList.append(videoSlide);
      
      if (this.initialVideoThumbnailSlides && this.initialVideoThumbnailSlides[0]) {
        const videoThumbnailSlide = this.initialVideoThumbnailSlides[0].cloneNode(true);
        videoThumbnailSlide.style.opacity = 1;
        thumbnailList.append(videoThumbnailSlide);
      }
    }

    // Reinitialize media gallery and enable zoom functionality
    this.mediaGallery.init();
    enableZoomOnHover?.(2); // See magnify.js
  }

  /**
   * Updates media gallery by comparing current DOM with new HTML content
   * Efficiently adds/removes/reorders media items without full replacement
   * @param {Document} html - Parsed HTML document containing updated media
   */
  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // Refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  /**
   * Fetches and renders updated product information for the current variant
   * Updates pricing, inventory, SKU, and other variant-specific content
   */
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // Prevent unnecessary UI changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        // Update media gallery if not using a metavariant
        if (!this.metavariant) {
          this.updateMedia(html);
        }

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        // Show volume pricing and quantity rules
        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        // Update add to cart button state
        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        // Publish variant change event for other components
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .finally(() => {
          if (typeof replaceContent === 'function') {
            replaceContent();
          }
      });
  }

  /**
   * Toggles the add to cart button state and text
   * @param {boolean} disable - Whether to disable the button
   * @param {string} text - Text to display on the button
   */
  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const isPreorder = addButton.dataset.preorder === 'true';
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (isPreorder) {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }

    }
  }

  /**
   * Sets the product as unavailable and hides relevant UI elements
   * Used when no variant matches the current selection
   */
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  /**
   * Gets variant data from JSON script tag, with caching
   * @returns {Array} Array of variant objects
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-variants]').textContent);
    return this.variantData;
  }

  /**
   * Gets metavariant data from JSON script tag, with caching
   * @returns {Array} Array of metavariant objects
   */
  getMetavariantData() {
    this.metavariantData = this.metavariantData || JSON.parse(this.querySelector('[type="application/json"][data-metavariants]').textContent);
    return this.metavariantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      let url = this.dataset.url;
      // Add the locale root to the URL if it's not already there
      if (Shopify.routes.root.includes(Shopify.locale) && !url.startsWith(Shopify.routes.root)) {
        url = `${Shopify.routes.root}${url}`;
      }

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          const loadedEvent = new CustomEvent('product-recommendations:loaded', { bubbles: true });
          this.dispatchEvent(loadedEvent);
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.variantImages = this.querySelectorAll('img[data-variant-id]');
    this.swatches = this.querySelectorAll('.variant-swatch');
    Array.from(this.swatches).forEach((swatch) => {
      swatch.addEventListener('focus', this.onSwatchActivate.bind(this));
      const supportsHover = window.matchMedia('(hover: hover)').matches;
      swatch.addEventListener(supportsHover ? 'mouseenter' : 'click', this.onSwatchActivate.bind(this));
    });
  }

  onSwatchActivate(event) {
    event.preventDefault();

    const { variantId } = event.target.dataset;
    const variantImage = this.querySelector(`img[data-variant-id="${variantId}"]`);

    if (variantImage) {
      Array.from(this.variantImages).forEach((image) => {
        image.classList.remove('active');
      });
      variantImage.classList.add('active');
    }

    const linkElement = this.querySelector('[id^="CardLink-"]');
    const newUrl = new URL(linkElement.getAttribute('href'), window.location.origin);
    newUrl.searchParams.set('variant', variantId);
    linkElement.setAttribute('href', newUrl.href);
  }
}

customElements.define('product-card', ProductCard);

class CookieSettings extends HTMLElement {
  constructor() {
    super();

    if (!window.privacyBanner) {
      this.remove();
      return;
    }
    
    this.querySelector('a').addEventListener('click', this.onButtonClick);
  }

  onButtonClick(event) {
    event.preventDefault();
    window.privacyBanner.showPreferences();
  }
}

customElements.define('cookie-settings', CookieSettings);

class LanguageSelector extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('load', () => this.initialize());
  }

  initialize() {
    if (!window.Weglot) {
      return;
    }

    if (Weglot.initialized) {
      this.createLanguageDropdown();
      return;
    }

    Weglot.on('initialized', () => this.createLanguageDropdown());
  }

  createLanguageDropdown() {
    const availableLanguages = Weglot.options.languages
      .map(language => language.language_to)
      .concat(Weglot.options.language_from);

    const selectList = this.querySelector('select');
    const currentLang = Weglot.getCurrentLang();

    availableLanguages.forEach(lang => {
      const option = document.createElement('option');
      option.value = lang;
      option.text = lang.toUpperCase();
      if (lang === currentLang) {
        option.selected = 'selected';
      }
      selectList.appendChild(option);
    });

    selectList.addEventListener('change', () => {
      Weglot.switchTo(selectList.value);
    });

    Weglot.on('languageChanged', lang => {
      selectList.value = lang;
    });

    this.style.opacity = 1;
  }
}

customElements.define('language-selector', LanguageSelector);



